import React from 'react';
import Hero from '../components/Hero/Hero';
import BestSellers from '../components/bestSeller/BestSellers';
import { Offers } from '../components/offers/Offers';
import NewCollections from '../components/NewCollections/NewCollections';
import Newsletter from '../components/newsLetter/NewsLetter';
import CategoryComponent from '../components/Category';
import { COLORS } from '../components/assets/constants/theme.js';
import BrandComponent from '../components/BrandComponent.jsx';
import ProductRow from '../components/ProductRow.jsx';
import BudgetProducts from '../hooks/budgetProduct.js';
import MidRangeProduct from '../hooks/midRangeProducts.js';
import PremiumProduct from '../hooks/premiumProducts.js';
import NewCollectionsCall from '../hooks/NeCollectionsCall.js';
import Products from '../hooks/Productcall.js';
import ProductGrid from '../components/ProductGrid.jsx';

export const Shop = () => {
  
  const {productData: productData, error: error, isLoading: isLoading,hasMore:hasMore, fetchProducts: fetchProducts} = Products();

  const {productData: newProductData, error: newError, isLoading: newIsLoading} = NewCollectionsCall();
  const {
    productData: budgetData,
    error: budgetError,
    isLoading: budgetIsLoading,
  } = BudgetProducts();

  const {
    productData: midRangeData,
    error: midRangeError,
    isLoading: midRangeIsLoading,
  } = MidRangeProduct();

  const {
    productData: premiumData,
    error: premiumError,
    isLoading: premiumIsLoading,
  } = PremiumProduct();
  

  return (
    <div>
    
      <Hero />

      {/* New Collections Section */}
      <ProductRow
      title="New Collections"
      products={newProductData}
      isLoading={newIsLoading}
      error={newError}
      seeAllLink="/full-product/new-collections"
    />

      {/* Product Row for Budget Products */}
      <ProductRow
        title="Budget Class"
        products={budgetData}
        isLoading={budgetIsLoading}
        error={budgetError}
        seeAllLink="/full-product/budget-class"
      />

      {/* Product Row for Mid-Range Products */}
      <ProductRow
        title="Middle Class"
        products={midRangeData}
        isLoading={midRangeIsLoading}
        error={midRangeError}
        seeAllLink="/full-product/mid-class"
      />

      {/* Product Row for Premium Products */}
      <ProductRow
        title="Premium Class"
        products={premiumData}
        isLoading={premiumIsLoading}
        error={premiumError}
        seeAllLink="/full-product/premium-class"
      />

      <ProductGrid
            //title={tempTitle}
            products={productData}
            isLoading={isLoading}
            error={error}
            hasMore={hasMore}
            fetchMore={fetchProducts}
            columns={{ xs: 2, md: 3, lg: 4 }}
          />

          
      {/* <BestSellers /> */}
      {/* Uncomment if needed */}
      {/* <Offers /> */}
      {/* <Newsletter /> */}
    </div>
  );
};

export default Shop;
